import React from "react";

const ButtonSubmit = ({ disabled = false }) => {
  return (
    <button
      name="send-request-piloto"
      type="submit"
      className="submit"
      style={{ marginLeft: "5px" }}
      disabled={disabled}
    >
      Enviar
    </button>
  );
};

export default ButtonSubmit;
